import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terraineditor',
  templateUrl: './terraineditor.component.html',
  styleUrls: ['./terraineditor.component.css']
})
export class TerraineditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/terraineditor/terraineditor.component.ts